import {Tile as TileLayer} from 'ol/layer.js';
import TileWMS from 'ol/source/TileWMS.js';
import {Layer} from './Layer.js';
import Library from './Library.js';
import {getMapLayers} from './config.js';

export class Animate {
    layers = [];
    labels = [];
    timeout = undefined;
    active_layer = 0;
    dwell = 1000;
    delay = 300;
    looping = false;
    label_target = "label_loop";
    opacity = 1;

    constructor(layers, labels, settings = {}){
        //if( settings.num_images == undefined ) settings['num_images'] = 6;
        if( settings['looping'] ) this.looping = settings['looping'];
        if( settings['label_target'] ){
            this.label_target = settings['label_target'];
            delete settings['label_target'];
        };
        this.layers = layers;
        console.info( labels );
        this.labels = labels;
        this.animate();
    }

    animate(){
        if( !this.looping ) return;
        this.step(1);
        let delay = this.delay;
        if( this.active_layer == this.layers.length-1 ) delay = this.dwell;
        this.timeout = setTimeout( this.animate.bind(this), delay );
    }

    increment(val){
        if( this.looping ){
            if( val > 0 && this.delay > 100 )
                this.delay -= 200;
            else if( val < 0 && this.delay < 1000 )
                this.delay += 200;
        } else {
            this.step(val);
        }
    }
    
    isLooping(){
        return this.looping;
    }

    step(val){
        let ind = this.active_layer;
        this.active_layer += val;
        if( this.active_layer >= this.layers.length )
            this.active_layer = 0;
        else if( this.active_layer < 0 )
            this.active_layer = this.layers.length;
        this.layers[ind].layer.setOpacity(0);
        //console.info( 'step to', this.active_layer );
        this.layers[this.active_layer].layer.setOpacity(this.opacity);
        Library.setDivText( this.label_target, this.labels[this.active_layer] );
    }

    setLooping(val){
        if( val == undefined ){
            this.looping = this.looping ? false: true;
            if( this.looping ) this.animate();
        }
        else
            this.looping = val;
        Library.setButtonValue( "loop_control", this.looping? "Pause": "Loop");
    }

    setOpacity(val){
        this.opacity = val;
    }

}
